<template>
  <Modal class="modalUserMagnament" :showMask="true" @onCancel="close">
    <template v-slot:header>
      <div class="modalUserMagnament__header">
        <h2 class="modalUserMagnament__title">{{ title + " usuario" }}</h2>
        <button class="modalUserMagnament__close" @click="close">
          <iconic class="modalUserMagnament__icon" name="close" />
        </button>
      </div>
    </template>
    <template v-slot:body>
      <div class="modalUserMagnament__body">
        <div class="modalUserMagnament__contentOptions">
          <div class="modalUserMagnament__contentOptions" v-for="option in getOptions" :key="option.index">
            <button :class="['modalUserMagnament__buttonOption', option.index === optionSelected && 'modalUserMagnament__buttonOption--selected']" @click="setOption(option.index)">
              <span>{{ option.name }}</span>
              <iconic
                :class="`modalUserMagnament__icon modalUserMagnament__icon--${hasRequiredFiled[option.component] ? 'aprove' : 'closeBold'}`"
                :name="hasRequiredFiled[option.component] ? 'aprove' : 'closeBold'" />
            </button>
            <keep-alive>
              <component v-if="option.component === currentComponent && screenWidth <= 768" :is="currentComponent" :ref="componentRefName(option.component)" :key="option.component" />
            </keep-alive>
          </div>
        </div>
        <div class="modalUserMagnament__contentData" v-if="screenWidth > 768">
          <keep-alive>
            <component :is="currentComponent" :ref="componentRefName(currentComponent)" :key="currentComponent" />
          </keep-alive>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="modalUserMagnament__fotter">
        <button class="modalUserMagnament__buttonAction modalUserMagnament__buttonAction--cancel" @click="close">Cancelar</button>
        <button class="modalUserMagnament__buttonAction" :disabled="!hasAllRequiredFiled || !valuesChanged.length" @click="updateUser" v-if="hasAllRequiredFiled && valuesChanged.length && isEditUser">
          {{ title }}
        </button>
        <button class="modalUserMagnament__buttonAction" :disabled="!hasAllRequiredFiled || !valuesChanged.length" @click="createUser" v-else-if="optionSelected === getOptions.length">
          {{ title }}
        </button>

        <button
          v-if="currentComponent !== 'UserPlatforms' && optionSelected !== getOptions.length"
          class="modalUserMagnament__buttonAction"
          :disabled="!hasRequiredFiled[currentComponent]"
          @click="nextStep">
          Siguiente
        </button>

        <button v-if="currentComponent === 'UserPlatforms'" class="modalUserMagnament__buttonAction" :disabled="!hasRequiredFiled[currentComponent]" @click="nextStep">Guardar</button>
      </div>
    </template>
  </Modal>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import Swal from "sweetalert2";

  export default {
    components: {
      Modal: () => import("@/components/modals/Modal.vue"),
      TypeUser: () => import("@/components/user/modalMagnamentUser/TypeUser.vue"),
      ApplicationsUser: () => import("@/components/user/modalMagnamentUser/ApplicationsUser.vue"),
      PersonalData: () => import("@/components/user/modalMagnamentUser/PersonalData.vue"),
      InformationRoleModel: () => import("@/components/user/modalMagnamentUser/InformationRoleModel.vue"),
      UserCredentials: () => import("@/components/user/modalMagnamentUser/UserCredentials.vue"),
      UserPlatforms: () => import("@/components/user/modalMagnamentUser/UserPlatforms.vue"),
      UserLocation: () => import("@/components/user/modalMagnamentUser/UserLocation.vue"),
      UserPolicies: () => import("@/components/user/modalMagnamentUser/UserPolicies.vue"),
    },
    data() {
      return {
        title: "Crear",
        typeOptions: {
          TypeUser: "Configuración de cuenta",
          PersonalData: "Datos personales",
          UserLocation: "Asignación empresarial",
          InformationRoleModel: "Informacion modelo",
          ApplicationsUser: "Aplicaciones",
          UserCredentials: "Credenciales de usuario",
          UserPlatforms: "Plataformas",
          UserPolicies: "Politicas de usuario",
        },
        optionsCouldView: [1],
        cloneDataToEdit: {},
        cloneRolesApps: {},
        requiredValues: {},
        cachedPlatformsData: { accounts: [], isValid: true },
        userPlatformsRef: null,
        initialPolicesSnapshot: {},
      };
    },
    computed: {
      ...mapGetters("applications", {
        getAppByName: "getAppByName",
      }),
      ...mapGetters("policies", {
        policiesDb: "policiesDb",
      }),
      user() {
        return this.$store.state.user.dataUser;
      },
      isEditUser() {
        return !!this.user?._id;
      },
      platformTypes() {
        const types = [];
        const accountType = this.user?.accountType;
        if (accountType) types.push(accountType);

        const raw = this.user.platformType;
        if (Array.isArray(raw)) return [...new Set([...types, ...raw])];
        if (!raw) return types;
        types.push(raw);
        return types;
      },
      isGroupAccount() {
        const { role, accountType, platformType } = this.user || {};
        if (accountType === "group") return true;
        if (role !== "model") return false;

        const list = Array.isArray(platformType) ? platformType : platformType ? [platformType] : [];
        return list.includes("group");
      },
      roleSelected() {
        return this.user.role;
      },
      getOptions() {
        const typeOptions = this.simpleClone(this.typeOptions);

        if (this.isEditUser) {
          delete typeOptions.TypeUser;
          if (this.$userData.role === "coordinator") {
            delete typeOptions.PersonalData;
            delete typeOptions.ApplicationsUser;
            delete typeOptions.UserCredentials;
            delete typeOptions.UserPlatforms;
            delete typeOptions.UserPolicies;
          }
        }
        if (this.roleSelected === "superadmin") {
          delete typeOptions.UserPolicies;
        }
        if (this.roleSelected !== "model") {
          delete typeOptions.InformationRoleModel;
          delete typeOptions.UserPlatforms;
        }
        if (this.isGroupAccount) {
          delete typeOptions.PersonalData;
        }
        return Object.entries(typeOptions).map(([component, val], index) => ({ name: val, index: index + 1, component }));
      },
      optionSelected() {
        return this.$store.state.user.toShowInMagnament;
      },
      currentComponent() {
        return this.getOptions.find(({ index }) => index === this.optionSelected)?.component || "";
      },
      screenWidth() {
        return this.$store.state.screen.width;
      },
      hasRequiredFiled() {
        const requiredValues = this.simpleClone(this.requiredValues);

        if (this.isEditUser) {
          delete requiredValues.TypeUser;
          delete requiredValues.ApplicationsUser;
          if (this.$userData.role === "coordinator") {
            delete requiredValues.PersonalData;
            delete requiredValues.ApplicationsUser;
            delete requiredValues.UserCredentials;
            delete requiredValues.UserPlatforms;
            delete requiredValues.UserPolicies;
          }
        }
        if (this.roleSelected !== "model") {
          delete requiredValues.InformationRoleModel;
          delete requiredValues.UserPlatforms;
        }

        if (this.isGroupAccount) {
          delete requiredValues.PersonalData;
          requiredValues.InformationRoleModel = ["artisticName", "entrydate"];
        }

        const validateRequiredValues = Object.entries(requiredValues).map(([key, val]) => ({
          [key]: val.every((item) => {
            if (["roles", "companies"].includes(item)) {
              return this.$store.state.user.dataUser[item]?.length;
            }
            return !this.$store.state.user.dataUser.hasOwnProperty(item) || this.$store.state.user.dataUser[item];
          }),
        }));

        return Object.assign({}, ...validateRequiredValues);
      },

      hasAllRequiredFiled() {
        return Object.values(this.hasRequiredFiled).every((val) => val);
      },
      valuesChanged() {
        const dataClone = this.cloneDataToEdit;
        const dataSend = this.$store.state.user.dataUser;
        const rolesAppsChanged = this.rolesAppsChanged;
        const changedRoles = this.rolesChanged;
        const policesChanged = this.policesChanged;

        const data = Object.entries(dataClone || {}).reduce((acc, [key, val]) => {
          if (typeof val === "undefined") return acc;

          const newVal = dataSend?.[key];
          const equal = val && typeof val === "object" ? JSON.stringify(val) === JSON.stringify(newVal) : val === newVal;
          if (!equal) acc.push({ [key]: newVal });

          return acc;
        }, []);

        if (Object.keys(rolesAppsChanged).length) data.push(rolesAppsChanged);
        if (Object.keys(changedRoles).length) data.push(changedRoles);
        if (Object.keys(policesChanged).length) data.push(policesChanged);
        if (Object.keys(this.companiesChanged).length) data.push(this.companiesChanged);

        return data;
      },

      rolesAppsChanged() {
        const dataSend = this.$store.state.user.dataUser.rolesApp;
        const dataClone = this.cloneDataToEdit.rolesApp;

        const keyAppsSend = Object.keys(dataSend).map((key) => key);
        const keyAppsClone = Object.keys(dataClone).map((key) => key);

        const hasChangedData =
          keyAppsSend.length !== keyAppsClone.length ||
          keyAppsSend.some((key) => {
            if (!keyAppsClone.includes(key)) return true;
            const current = this.normalizeRoleEntry(dataSend[key]);
            const initial = this.normalizeRoleEntry(dataClone[key]);

            const sameRole = current.role === initial.role;
            const sameModules = JSON.stringify(current.modules) === JSON.stringify(initial.modules);

            return !(sameRole && sameModules);
          });

        return hasChangedData ? { rolesApp: dataSend } : {};
      },
      companiesChanged() {
        const dataSend = this.$store.state.user.dataUser.companies;
        const dataClone = this.cloneDataToEdit.companies;
        const hasChangedData = dataSend.length !== dataClone.length || dataSend.some((key) => !dataClone.includes(key));

        return hasChangedData ? { companies: dataSend } : {};
      },
      rolesChanged() {
        const dataSend = this.$store.state.user.dataUser.roles?.[0];
        const dataClone = this.cloneDataToEdit.roles?.[0];

        return dataSend === dataClone ? {} : { roles: [dataSend] };
      },

      isSatelite() {
        return this.$store.state.user.dataUser?.office === "Satelite";
      },
      policesChanged() {
        this.$store.state.user.numTest;
        const currentHash = this.hashPolicies(this.$store.state.user.dataUser.polices || {});
        return currentHash !== this.policiesHashSnapshot ? { polices: this.$store.state.user.dataUser.polices } : {};
      },
    },
    watch: {
      roleSelected(newVal) {
        this.$store.dispatch("user/changeRoleInDataUser", newVal);
      },
      getOptions(newOptions) {
        const exists = newOptions.some(({ index }) => index === this.optionSelected);
        if (!exists && newOptions.length) {
          this.$store.state.user.toShowInMagnament = newOptions[0].index;
        }
      },
      isSatelite(val) {
        if (val) {
          const findPolice = this.policiesDb.find(({ key }) => key === "login-from-any-place");
          this.$store.state.user.dataUser.polices["login-from-any-place"] = { ...findPolice, status: true };
        } else {
          delete this.$store.state.user.dataUser.polices["login-from-any-place"];
        }
        this.$store.state.user.numTest++;
      },
    },
    methods: {
      ...mapActions("policies", { getPolicies: "getPolicies" }),

      componentRefName(component) {
        if (!component) return null;
        if (component === "UserPlatforms") return "UserPlatformsRef";
        if (component === "TypeUser") return "TypeUser";
        return null;
      },
      getComponentInstance(refName) {
        const componentRef = this.$refs[refName];
        return Array.isArray(componentRef) ? componentRef?.[0] : componentRef;
      },
      simpleClone(value) {
        try {
          if (typeof structuredClone === "function") {
            return structuredClone(value);
          }

          return JSON.parse(JSON.stringify(value));
        } catch (error) {
          console.log("error :>> ", error);
          return value;
        }
      },
      async persistPermissions(userId) {
        const appsComp = this.getComponentInstance("ApplicationsUser");
        if (!appsComp || typeof appsComp.savePermissionsForUser !== "function") return { success: true };

        const targetUserId = userId || this.$store.state.user.userSelected?._id || this.$store.state.user.dataUser?._id;
        if (!targetUserId) return { success: true };

        const assignedBy = this.$store.getters["user/getProfile"]?._id || "";
        return appsComp.savePermissionsForUser(targetUserId, assignedBy);
      },
      normalizeRoleEntry(entry) {
        if (!entry) return { role: "", modules: [] };

        const role = Array.isArray(entry) ? entry[0] || "" : entry?.role || entry?.[0] || "";
        const modules = Array.isArray(entry?.modules) ? entry.modules : [];

        return { role, modules };
      },

      normalizeAllowedRegisters(policy = {}) {
        const payload = policy?.payload;
        let list = [];

        if (Array.isArray(payload)) {
          list = payload;
        } else if (Array.isArray(payload?.allowedRegisters)) {
          list = payload.allowedRegisters;
        } else if (payload && typeof payload === "object") {
          list = Object.keys(payload).filter((key) => !!payload[key]);
        }

        const normalized = list.map((item) => String(item).trim().toLowerCase()).filter((item) => !!item);

        const unique = normalized.filter((item, index, array) => array.indexOf(item) === index);

        if (unique.includes("both")) {
          return unique;
        }

        const limitedValues = ["free", "private"];
        return limitedValues.filter((item) => unique.includes(item));
      },

      normalizePolicies(polices = {}) {
        return Object.entries(polices).reduce((acc, [key, policy]) => {
          if (!policy) return acc;

          if (key === "assign-permission-free-private") {
            acc[key] = {
              status: !!policy.status,
              allowedRegisters: this.normalizeAllowedRegisters(policy),
            };
          } else {
            acc[key] = {
              status: !!policy.status,
              payload: policy.payload ?? null,
              value: policy.value ?? null,
            };
          }

          return acc;
        }, {});
      },
      hashPolicies(polices = {}) {
        const normalized = this.normalizePolicies(polices || {});
        return JSON.stringify(normalized);
      },

      close() {
        this.$store.state.user.dataUser.accountType = "individual";
        this.$store.state.user.dataUser.platformType = null;
        this.$store.state.user.toShowInMagnament = 0;
        this.$store.dispatch("user/changeRoleInDataUser", "model");
        this.userPlatformsRef = null;
      },
      setOption(option) {
        if (!this.isEditUser) {
          this.verifyNext();

          if (!this.optionsCouldView.includes(option)) {
            return;
          }
        }

        this.$store.state.user.toShowInMagnament = option;
      },
      handleProcess(sparkCreation) {
        const { success, message } = sparkCreation;
        const template = `
          <div style="display: flex; align-items: center; gap: 10px; width: 60%; margin: 0 auto 10px;">
            <i style="color: ${success ? "#3bb54a;" : "#f7c325;"}" class="fas fa-${success ? "check" : "exclamation"}-circle"></i>
            <div style="text-align: left">${message}</div>
          </div>
        `;
        return template;
      },
      async createUser() {
        if (!this.verifyAll() || !this.hasAllRequiredFiled) return;

        const { accounts, isValid } = this.cachedPlatformsData;

        if (!isValid) {
          this.$toast.error("Complete los campos de plataformas antes de continuar");
          return;
        }

        const deleteExtraFixed = this.user.room || this.user.workShiftName ? await this.requireDeleteExtraFixed(this.user) : false;

        if (deleteExtraFixed === null) return;

        const payload = {
          ...deleteExtraFixed,
          accounts,
        };

        const { success, sparkCreation, error, newUser } = await this.$store.dispatch("user/createUser", payload);

        const msgSwal = {
          text: error || "Usuario creado correctamente.",
          icon: success ? "success" : "error",
          confirmButtonColor: "#bd0909",
        };

        if (!error) msgSwal.html = this.handleProcess(sparkCreation);

        Swal.close();
        Swal.fire(msgSwal);

        if (success) {
          const child = this.userPlatformsRef || this.getComponentInstance("UserPlatformsRef") || this.getComponentInstance("UserPlatforms");
          const shouldSavePlatforms = accounts?.length && child && newUser?._id;

          if (shouldSavePlatforms) {
            this.$store.state.user.dataUser._id = newUser._id;
            const ok = await child.savePlatforms();
            if (!ok) return;
          }

          const permResult = await this.persistPermissions(newUser?._id);
          if (!permResult.success) {
            this.$toast.error(permResult.error);
            return;
          }

          this.close();
        }
      },

      async updateUser() {
        if (!this.verifyAll() || !this.hasAllRequiredFiled || !this.valuesChanged.length) return;

        const body = Object.assign({}, ...this.valuesChanged);
        body._id = this.user._id;
        body.host = this.getAppByName("reservations").api || "";
        body.deleteExtraFixed = body.room || (body.workShiftName && this.user.role === "model") ? await this.requireDeleteExtraFixed(body) : false;

        if (body.deleteExtraFixed === null) return;

        const { success, userEdited, error } = await this.$store.dispatch("user/updateUser", body);

        Swal.close();
        Swal.fire({
          text: error ? error : "Usuario editado correctamente.",
          icon: success ? "success" : "error",
          confirmButtonColor: "#bd0909",
        });

        if (error && error === "Habitación ocupada") {
          this.$store.dispatch("users/fetchUsers");
        }
        if (success) {
          const permResult = await this.persistPermissions(body._id);
          if (!permResult.success) {
            this.$toast.error(permResult.error);
            return;
          }

          this.policiesHashSnapshot = this.hashPolicies(this.$store.state.user.dataUser.polices || {});
          this.$store.commit("users/update", userEdited);
          this.close();
        }
      },
      async requireDeleteExtraFixed(body) {
        const extraFixedsFinded = await this.verifyExtraFixed(body._id, body.room, body.workShiftName);

        if (!extraFixedsFinded.length) {
          return false;
        }

        const isPlural = extraFixedsFinded.length > 1;

        let usersWithExtraFixed = "";
        extraFixedsFinded.forEach((user) => (usersWithExtraFixed += `, ${user.artisticName || user.user}`));

        const { isConfirmed } = await this.$alerts.dataSendConfirm({
          message: `${isPlural ? "Los" : "El"} usuario${isPlural ? "s" : ""}${usersWithExtraFixed} tiene${isPlural ? "n" : ""} reservas extras fijas en esta habitación y turno, ¿quieres cancelarlas?`,
          buttonTextYes: "Si, Cancelar",
          buttonTextNo: "No",
        });

        return isConfirmed || null;
      },
      async verifyExtraFixed(_id, room, workShiftName) {
        try {
          let query = "";

          if (_id) query += `userId=${_id}&`;
          if (room) query += `room=${room}&`;
          if (workShiftName) query += `workShift=${workShiftName}&`;

          const { data } = await this.$axios.get(`/roomAvailable?${query}`);
          const { extraFixeds, error } = data;

          if (error) {
            throw new Error(error);
          }

          return extraFixeds;
        } catch (error) {
          console.log(error);
          return [];
        }
      },
      verifyNext() {
        const componentRef = this.getComponentInstance(this.componentRefName(this.currentComponent) || this.currentComponent);
        const response = componentRef?.verifyNext?.() ?? true;
        const optionSelected = this.optionSelected;

        if (response) {
          this.optionsCouldView[optionSelected] = optionSelected + 1;
        } else {
          this.optionsCouldView.splice(optionSelected);
        }
      },
      verifyAll() {
        const response = this.getOptions.every(({ index, component }) => {
          const componentRef = this.getComponentInstance(this.componentRefName(component) || component);
          const isVeify = componentRef?.verifyNext?.() ?? true;

          if (!isVeify) {
            this.$store.state.user.toShowInMagnament = index;
          }

          return isVeify;
        });
        return response;
      },
      async savePlatformsAndNext() {
        const child = this.getComponentInstance("UserPlatformsRef") || this.getComponentInstance("UserPlatforms");
        if (!child) return;

        const ok = await child.savePlatforms();
        if (!ok) return;

        this.setOption(this.optionSelected + 1);
      },
      async nextStep() {
        if (this.currentComponent === "UserPlatforms") {
          const child = this.getComponentInstance("UserPlatformsRef") || this.getComponentInstance("UserPlatforms");
          this.userPlatformsRef = child || this.userPlatformsRef;

          if (!child || typeof child.getPlatformData !== "function") {
            this.$toast.error("No se pudo acceder al componente de plataformas");
            return;
          }

          const { accounts, isValid } = child.getPlatformData();

          if (!isValid) {
            this.$toast.error("Complete los campos de plataformas antes de continuar");
            return;
          }

          this.cachedPlatformsData = { accounts, isValid };

          if (this.isEditUser) {
            const ok = await child.savePlatforms();
            if (!ok) return;
          }
        }

        if (this.optionSelected < this.getOptions.length) {
          this.setOption(this.optionSelected + 1);
        }
      },
    },
    created() {
      this.cloneDataToEdit = this.simpleClone(this.$store.state.user.dataUser);
      const requiredValues = this.simpleClone(this.$store.state.user.requiredValues);
      this.initialPolicesSnapshot = this.normalizePolicies(this.cloneDataToEdit?.polices || {});
      this.policiesHashSnapshot = this.hashPolicies(this.cloneDataToEdit?.polices || {});

      if (this.isEditUser) {
        requiredValues["PersonalData"].pop();
        requiredValues["UserCredentials"].pop();
        requiredValues["UserCredentials"].pop();

        this.title = "Editar";
      }

      this.requiredValues = requiredValues;
    },
    async mounted() {
      await this.getPolicies();
    },
  };
</script>

<style lang="scss">
  .modalUserMagnament {
    .modal-g__container {
      @include Flex(column, flex-end, flex-end);
      width: 1000px;
      max-width: 1440px;
      padding: 0;
      gap: $mpadding;
    }
    &__header {
      @include Flex(row, space-between);
      width: 100%;
      padding: $mpadding;
      border-bottom: 1px solid #c4c4c4;
    }
    &__title {
      font-weight: lighter;
    }
    &__close {
      @include Flex(row);
      height: 35px;
      width: 35px;
      color: $primary-color;
      border: none;
      border-radius: 50%;
      background: none;
      cursor: pointer;
      transition: 0.3s ease-in-out;
      &:hover {
        background: #bd09092e;
      }
    }
    &__body {
      @include Flex(row, center, flex-start);
      width: 100%;
      padding: 0 $mpadding;
      gap: 20px;
      overflow: auto;
      scrollbar-width: thin;
      &::-webkit-scrollbar {
        width: 8px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 4px;
      }
    }
    &__contentData,
    &__contentOptions {
      @include Flex(column, flex-start, flex-start);
      gap: $mpadding;
    }
    &__contentOptions {
      width: 300px;
      flex-shrink: 0;
    }
    &__contentData {
      flex: 1;
      height: 520px;
      padding: 0 3px;
      overflow-y: auto;
    }
    &__buttonOption {
      @include Flex(row, space-between);
      width: 100%;
      padding: $mpadding / 1.5 $mpadding;
      font-family: $newFont_semiBold;
      font-size: 18px;
      color: #000;
      text-align: start;
      font-weight: 600;
      background: #ffffff;
      border: 1px solid #e2e2e2;
      border-radius: 6px;
      &--selected {
        background: #f7f7f7;
      }
    }
    &__fotter {
      @include Flex(row);
      gap: $mpadding;
      padding-bottom: $mpadding;
      padding-right: 20px;
    }
    &__buttonAction {
      width: 134px;
      height: 40px;
      font-weight: 600;
      color: white;
      border: 1px solid $primary-color;
      padding: 10px;
      border-radius: 8px;
      background: $primary-color;
      &--cancel {
        color: $primary-color;
        background-color: white;
      }
    }
    &__icon {
      &--aprove {
        color: #209e0c;
      }
      &--closeBold {
        color: $primary-color;
      }
    }

    @media screen and (min-width: $tablet-width) {
      &__fotter {
        gap: 39px;
      }
      &__buttonAction {
        width: 160px;
      }
    }
    @media screen and (min-width: 769px) {
      &__body {
        overflow: hidden;
      }
    }
  }
</style>
